import { render, staticRenderFns } from "./CallCentreView.vue?vue&type=template&id=181b4718"
import script from "./CallCentreView.vue?vue&type=script&lang=ts"
export * from "./CallCentreView.vue?vue&type=script&lang=ts"
import style0 from "./CallCentreView.vue?vue&type=style&index=0&id=181b4718&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports